import { useCallback, useState } from 'react';

type OptionValues = Readonly<Record<string, unknown>>;

export const useCanvasOptions = (page: string | null) => {
  const [reported, setReported] = useState<{ page: string | null; values: OptionValues } | null>(null);
  const onOptions = useCallback((values: OptionValues) => setReported({ page, values }), [page]);
  return { lastOptions: reported?.page === page ? reported.values : null, onOptions };
};
